<template>
  <div>
    <div class="content" v-html="gyData.tissue"></div>
  </div>
</template>
<script>
import Bus from "@/utils/bus.js";
import { getGywm } from "@/api/gywm.js";
export default {
  data() {
    return {
      gyData: []
    };
  },
  props: {
    title: {
      type: String
    }
  },
  mounted() {
    window.scroll(0, 0);
    this.getData();
  },
  methods: {
    async getData() {
      let gy = new FormData();
      gy.append("page", 1);
      gy.append("rows", 3);
      gy.append("dentity", this.title);
      let res = await getGywm(gy);
      this.gyData = res.rows[0];
    }
  }
};
</script>
<style lang="less" scoped>
@color: #ff7234;
.content {
  // width: calc(100vw - 60px);
  line-height: 2;
}
</style>